/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
    COMPANY_ORIGIN_EVENTFORMULAR,
    COMPANY_ORIGIN_IMPORT,
    COMPANY_ORIGIN_MANUAL,
} from 'utils/companies/companyOriginUtils'

export interface CompanyOriginOption {
    value: string
    label: string
}

export const useCompanyOriginOptions = () => {
    const { t } = useTranslation()

    return useMemo(() => [
        { value: COMPANY_ORIGIN_EVENTFORMULAR, label: t('Eventformular') },
        { value: COMPANY_ORIGIN_IMPORT, label: t('Import') },
        { value: COMPANY_ORIGIN_MANUAL, label: t('Manuelle Erfassung') },
    ], [t])
}
